export default "__VITE_ASSET__CbCyxA4t__"